import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class MenuService extends Service{
    constructor() {
        super();
        this.baseURL = 'menu';
    }

    findByHsmUserId(hsmUserId) {
        return fetch(SERVER_URL + this.baseURL+ '/findByHsmUserId/'+ hsmUserId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}